export default __webpack_public_path__ + "static/media/desk9.fc000cfa.png";